/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NotificationContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"BadgeTagContainer_settings">;
    readonly " $refType": "NotificationContainer_settings";
};
export type NotificationContainer_settings$data = NotificationContainer_settings;
export type NotificationContainer_settings$key = {
    readonly " $data"?: NotificationContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"NotificationContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BadgeTagContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '352e641c40fb8f866c652bda75da729f';
export default node;
